<template>
<div class="_direction-container" ref="directions" :class="darkMode ? 'dark-mode' : ''">
    <div class="_direction-logo" :class="darkMode ? 'dark-mode' : ''">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M47.9986 28.2603H0.0830078V31.0441H47.9986V28.2603Z" fill="#252628" />
            <path
                d="M0.0830078 48.0002H3.03555V44.7946H19.8229V33.828H0.0830078V48.0002ZM3.03555 36.6118H16.8703V42.0108H3.03555V36.6118Z"
                fill="#252628" />
            <path
                d="M22.6094 44.7947H33.7447V48.0003H36.7816V44.7947H47.9169V33.8281H22.6094V44.7947ZM36.7816 36.612H45.0487V42.0109H36.7816V36.612ZM25.5619 36.612H33.7447V42.0109H25.5619V36.612Z"
                fill="#252628" />
            <path d="M25.4759 0H14.1719V25.3919H25.4759V0ZM22.5234 22.6081H17.1244V2.86819H22.5234V22.6081Z"
                fill="#252628" />
            <path
                d="M31.2963 8.52021L36.6952 2.86819V25.4763H39.6478V8.52021L44.9624 2.86819V25.4763H47.9149V0H43.7814L39.6478 4.38664V0H35.5142L28.3438 7.42355V25.4763H31.2963V8.52021Z"
                fill="#252628" />
            <path
                d="M8.35149 25.4763H11.304V22.6924V0H7.17047L0 7.42355V22.6081V25.3919H2.95255H8.35149V25.4763ZM3.0369 8.52021L8.43585 2.86819V22.6081H3.0369V8.52021Z"
                fill="#252628" />
        </svg>
        <div class="_direction-close-btn" :class="darkMode ? 'dark-mode' : ''" @click="closePopUp">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#252628" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14.6669 14.6667C14.9273 14.4063 15.3494 14.4063 15.6098 14.6667L19.8525 18.9094L24.095 14.6669C24.3554 14.4065 24.7775 14.4065 25.0378 14.6669C25.2982 14.9272 25.2982 15.3494 25.0378 15.6097L20.7953 19.8522L25.0378 24.0948C25.2982 24.3551 25.2982 24.7772 25.0378 25.0376C24.7775 25.2979 24.3554 25.2979 24.095 25.0376L19.8525 20.7951L15.6098 25.0378C15.3494 25.2981 14.9273 25.2981 14.6669 25.0378C14.4066 24.7774 14.4066 24.3553 14.6669 24.095L18.9097 19.8522L14.6669 15.6095C14.4066 15.3492 14.4066 14.927 14.6669 14.6667Z"
                    fill="#252628" />
            </svg>
        </div>
    </div>
    <div class="_internal-list-container" :class="darkMode ? 'dark-mode' : ''">
        <div class="_internal-list">
            <div class="_internal-list__item" v-for="direction in directions.sections" :key="direction">
                <div class="_internal-list__link">
                    <img class="_internal-list__icon" :src="direction.img" :alt="direction.name" :title="direction.name"
                        loading="lazy" width="48" height="48">
                    <div>
                        <h4 class="_internal-list__title" :class="darkMode ? 'dark-mode' : ''" :title="direction.name">
                            {{ direction.name }} </h4>
                        <span class="_internal-list__desc" v-html="direction.desc"></span>
                    </div>
                    <a class="_link-full-block" :href="direction.url" :target="direction._blank === 'Y' ? '_blank' : ''" :title="direction.name"></a>
                </div>
                <div class="_internal-list-socials">
                    <a v-for="social in direction.items" :key="social" :href="social.url"
                        class="_internal-list-socials__item" :target="social._blank === 'Y' ? '_blank' : ''" :title="social.name">
                        <img :src="`/static/domrf-header-menu/dist/images/socials/${social.soc}.svg`"
                            :alt="social.name" class="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "Direction",
    props: {
        darkMode: {
            type: Boolean,
            default: false
        },
        directions: {
            type: Object,
            default: () => { },
            required: true,
        },
    },
    data() {
        return {
            allDirections: [],
        };
    },

    mounted() {

    },
    unmounted() {
        document.removeEventListener('click', this.handleClickOutside);
    },

    computed: {
    },
    methods: {
        outsideListener() {
            document.addEventListener('click', this.handleClickOutside);
        },
        handleClickOutside(event) {
            if (this.$refs.directions && !this.$refs.directions.contains(event.target)) {
                this.$emit('closeAllDirection', false);
            }
        },

        closePopUp() {
            this.$emit('closeAllDirection', false);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../styles/mixin/typography";

._direction {
    &-container {
        background-color: #fff;
        padding: 28px 0 24px 60px;
        display: flex;
        flex-direction: column;
        height: 100%;

        @media (max-width: 820px) {
            padding: 16px 0 16px 16px;
        }

        &.dark-mode {
            background-color: #252628;
        }
    }

    &-close-btn {
        cursor: pointer;
        padding-right: 24px;

        &.dark-mode {
            svg rect {
                stroke: #fff;
            }

            svg path {
                fill: #fff;

            }
        }

    }

    &-logo {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 50px;

        @media(max-width: 768px) {
            margin-bottom: 24px;
        }

        &.dark-mode {
            svg path {
                fill: #fff;
            }
        }
    }

    &-all {
        @include gilroy-600;
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: all 0.3s linear;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        white-space: nowrap;

        @media (max-width: 1460px) {
            display: none;
        }

        &:hover {
            color: #699b12;

            .direction-all__path {
                transition: fill 0.3s linear;
                fill: #699b12;
            }
        }

        &__mob {
            cursor: pointer;

            @media (min-width: 1461px) {
                display: none;
            }
        }
    }

    &-popup__header {
        display: flex;
        justify-content: space-between;
    }
}

._internal {
    &-list {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -0.75rem;
        margin-left: auto;
        max-width: 47rem;
        width: 47rem;

        @media(max-width: 820px) {
            width: 100%;
        }

        @media(max-width: 768px) {
            flex-direction: column;
        }

        &-container {
            overflow-y: auto;

            &::-webkit-scrollbar-track {
                border: 3px solid rgba(0, 0, 0, 0);
            }

            &::-webkit-scrollbar-thumb {
                background-color: #dedede;
                border: 0.25rem solid #fff;
                border-radius: 0.5rem;
            }

            &::-webkit-scrollbar {
                width: 12px;
            }

            &.dark-mode {
                &::-webkit-scrollbar-thumb {
                    background-color: #999;
                    border: 0.25rem solid #252628;
                    border-radius: 0.5rem;
                }
            }
        }

        &__item {
            margin-bottom: 0.5rem;
            padding: 0.5rem;
            width: 50%;

            &:nth-of-type(odd) {
                padding-left: 0;

            }

            @media(max-width: 768px) {
                width: 100%;
                padding: 0;
                margin-bottom: 1.5rem;
            }
        }

        &__link {
            align-items: flex-start;
            display: flex;
            position: relative;
        }

        &__icon {
            margin-right: 1.25rem;
            width: 48px;
        }

        &__title {
            @include gilroy-500;
            color: #252628;
            display: block;
            font-size: 1rem;
            line-height: 1.25;
            margin-bottom: 0.25rem;
            transition: color .3s;

            @media(max-width: 768px) {
                font-size: 14px;
                line-height: normal;
            }

            &.dark-mode {
                color: #fff;
            }
        }

        &__desc {
            @include gilroy-500;
            color: #737373;
            display: block;
            font-size: .875rem;
            line-height: 1.43;

            @media(max-width: 768px) {
                font-size: 12px;
                line-height: normal;
            }
        }

        &-socials {
            align-items: center;
            display: flex;
            margin-left: 4.25rem;
            margin-top: 0.5rem;
            width: calc(100% - 4.25rem);

            &__item {
                display: flex;

                &:not(:last-of-type) {
                    margin-right: 0.5rem;
                }
            }
        }

    }

}

._link-full-block {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;

}
</style>
